import { MessageType } from '../client/base';
export interface ProviderState {
  client: any;
  messages: MessageType[];
  token: string;
  url: string;
}
// Provider 实例管理
class ProviderManager {
  private providers = new Map<string, ProviderState>();

  // 注册 Provider
  register(providerId: string, data: {
    client: any;
    token: string;
    url: string;
  }) {
    this.providers.set(providerId, {
      ...data,
      messages: [],
    });
  }

  // 注销 Provider
  unregister(providerId: string) {
    this.providers.delete(providerId);
  }

  // 获取 Provider 数据
  getProvider(providerId: string): ProviderState | undefined {
    return this.providers.get(providerId);
  }

  // 添加消息到指定 Provider
  addMessage(providerId: string, message: MessageType) {
    const provider = this.providers.get(providerId);
    if (provider) {
      provider.messages.push(message);
    }
  }

  // 清空指定 Provider 的消息
  clearMessages(providerId: string) {
    const provider = this.providers.get(providerId);
    if (provider) {
      provider.messages = [];
    }
  }

  // 获取所有 Provider ID
  getProviderIds() {
    return Array.from(this.providers.keys());
  }
}

// 全局单例
export const providerManager = new ProviderManager();

// Hook 用于在组件中使用
export const useProviderManager = () => {
  return providerManager;
};
